// Centralized API endpoint definitions.
// Static paths are exported as string constants.
// Parameterized paths are exported as functions.
import { encodeSectionParam } from '../utils/sectionParam'

// ── Auth ──────────────────────────────────────────────────────
export const AUTH_VERIFY   = '/auth/verify'
export const AUTH_LOGIN    = '/auth/login'
export const AUTH_LOGOUT   = '/auth/logout'
export const AUTH_REFRESH  = '/api/auth/refresh'

// ── Claim ─────────────────────────────────────────────────────
export const CLAIM_DASHBOARD                          = '/claim/dashboard'
export const CLAIM_DRAFT                              = '/claim/draft'
export const claimDraft      = (id: string)          => `/claim/${id}/draft`
export const claimById       = (id: string)          => `/claim/${id}`
export const claimByUser     = (userId: string)      => `/claim/by-user/${encodeURIComponent(userId)}`
export const claimSubmit     = (id: string)          => `/claim/${id}/submit`
export const claimByUserAndCase = (userId: string, caseId: string) =>
  `/claim/by-user/${encodeURIComponent(userId)}/case/${encodeURIComponent(caseId)}`
export const cleanupOrphansByUser = (userId: string) =>
  `/claim/cleanup-orphans/${encodeURIComponent(userId)}`

// ── AI ────────────────────────────────────────────────────────
export const aiRetrainByUserCase = (userId: string, caseId: string) =>
  `ai/retrain/${encodeURIComponent(userId)}/${encodeURIComponent(caseId)}`
// userId/caseId-based AI endpoints
export const aiProcessByUserCase = (userId: string, caseId: string, includeOcr: boolean, includeBoxValue: boolean) =>
  `/ai/process/${encodeURIComponent(userId)}/${encodeURIComponent(caseId)}/?includeOcr=${includeOcr}&includeBoxValue=${includeBoxValue}`
export const aiProcessAggregateByUserCase = (userId: string, caseId: string, section: string) =>
  `/ai/process/${encodeURIComponent(userId)}/${encodeURIComponent(caseId)}/?includeAggregateFlag=true&section=${encodeURIComponent(section)}`
export const aiResultsByUserCase = (userId: string, caseId: string) =>
  `ai/results/${encodeURIComponent(userId)}/${encodeURIComponent(caseId)}`
export const aiDetectByUserCase = (userId: string, caseId: string) =>
  `ai/detect/${encodeURIComponent(userId)}/${encodeURIComponent(caseId)}?`

// ── Image ─────────────────────────────────────────────────────
// Note: no leading slash — resolved relative to baseURL (/api)
export const imageByUserCase     = (userId: string, caseId: string) =>
  `image/${encodeURIComponent(userId)}/${encodeURIComponent(caseId)}/`
export const imageByUserCaseAndSection = (userId: string, caseId: string, section: string) =>
  `image/${encodeURIComponent(userId)}/${encodeURIComponent(caseId)}/${encodeSectionParam(section)}`
export const imageByUserCaseSectionAndName = (userId: string, caseId: string, section: string, imageName: string) =>
  `image/${encodeURIComponent(userId)}/${encodeURIComponent(caseId)}/${encodeSectionParam(section)}/${encodeURIComponent(imageName)}`

// ── OCR ───────────────────────────────────────────────────────
export const OCR_SECTION_PROCESS = '/ocr/section/process'
export const OCR_PROCESS         = '/ocr/process'

// ── VIN ───────────────────────────────────────────────────────
export const vinDecode           = (vin: string)     => `/vin/${vin}`

// ── Reference / Attribute ─────────────────────────────────────
export const REF_SINGLE          = '/ref'
export const REF_BATCH           = '/ref/batch'
export const ATTRIBUTE           = '/attribute'
export const usageSubtypes = (vehicleType: 'TT' | 'TR', label: string) =>
  `/vvs-master/usage-subtypes/${vehicleType}/${encodeURIComponent(label)}`

// ── Help Content ──────────────────────────────────────────────
export const HELP_CONTENT_RESOLVE = '/help-content/resolve'
